"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const react_1 = __importDefault(require("react"));
const getObjectIdContextDefault_1 = __importDefault(require("./getObjectIdContextDefault"));
const ObjectIdContext_1 = require("./ObjectIdContext");
const withObjectIdPage = (configuration) => (PageComponent) => {
    const { getContextValue = getObjectIdContextDefault_1.default } = configuration || {};
    const WithObjectIdPage = props => {
        return (react_1.default.createElement(ObjectIdContext_1.ObjectIdContext.Provider, { value: {
                objectId: props.objectId,
                objectType: props.objectType,
                id: props.id,
            } },
            react_1.default.createElement(PageComponent, Object.assign({}, props))));
    };
    WithObjectIdPage.getInitialProps = (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        let pageProps = {};
        if (PageComponent.getInitialProps) {
            pageProps = yield PageComponent.getInitialProps(ctx);
        }
        const { objectId, id } = getContextValue(ctx);
        return Object.assign(Object.assign({}, pageProps), { objectId: objectId, id: id });
    });
    (0, hoist_non_react_statics_1.default)(WithObjectIdPage, PageComponent, {
        getInitialProps: true,
    });
    return WithObjectIdPage;
};
exports.default = withObjectIdPage;
//# sourceMappingURL=withObjectIdPage.js.map